<template>
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="8" cy="8" r="6"/>
    <line x1="8" y1="5" x2="8" y2="8"/>
    <line x1="8" y1="11" x2="8" y2="11"/>
  </svg>
</template>
